/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VmcHostUsageProxyResponse } from './vmcHostUsageProxyResponse';


export interface VmcHostUsageReportBulkResponse { 
    vmc_org_daily_max_usages?: Array<VmcHostUsageProxyResponse>;
    total_record_count?: number;
}

